import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import('@/views/login/login');
const MyStaffHome = () => import('@/views/myStaffHome/myStaffHome');
const AdminHome = () => import('@/views/adminHome/adminHome');
const MyExamine = () => import('@/views/myExamine/myExamine');
const MyVacate = () => import('@/views/myVacate/myVacate');
const OrganizationAdmin = () => import('@/views/organizationAdmin/organizationAdmin');
const ExamineAdmin = () => import('@/views/examineAdmin/examineAdmin');
const payInquiry = () => import('@/views/payInquiry/payInquiry');
const StaffManagement = () => import('@/views/staffManagement/staffManagement');
const StaffDetail = () => import('@/views/staffManagement/StaffDetail');

/*404错误页面*/
const Zoo404 = () => import('@/views/zoo404/zoo404');

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '/login',
      component: Login
    },
    {
      path: '/myStaffHome',
      name: 'myStaffHome',
      redirect: '/myStaffHome/myVacate',
      component: MyStaffHome,
      children: [
        {
          path: '/myStaffHome/myExamine',
          name: 'myExamine',
          component: MyExamine
        },
        {
          path: '/myStaffHome/myVacate',
          name: 'myVacate',
          component: MyVacate
        }
      ]
    },
    {
      path: '/adminHome',
      name: 'adminHome',
      redirect: '/adminHome/organizationAdmin',
      component: AdminHome,
      meta: { title: '首页' },
      children: [
        {
          path: '/adminHome/organizationAdmin',
          name: 'organizationAdmin',
          meta: { title: '组织管理' },
          component: OrganizationAdmin
        },
        {
          path: '/adminHome/staffManagement',
          name: 'staffManagement',
          meta: { title: '员工管理' },
          component: StaffManagement
        },
        {
          path: '/adminHome/staffManagement/staffDetail',
          name: 'staffDetail',
          meta: { title: '员工详情' },
          component: StaffDetail
        },
        {
          path: '/adminHome/examineAdmin',
          name: 'examineAdmin',
          meta: { title: '模板管理' },
          component: ExamineAdmin
        },
        {
          path: '/adminHome/payInquiry',
          name: 'payInquiry',
          meta: { title: '缴费查询' },
          component: payInquiry
        }
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      name: 'zoo404',
      component: Zoo404
    }
  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js